<ul><sib-main-submenu [item]="model" root="true" class="ultima-menu ultima-main-menu clearfix" [reset]="reset" visible="true"></sib-main-submenu></ul>